module.exports = __webpack_public_path__ + "static/media/page10_doma.908cf0f1.png";